var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "detail-summay-containter",
      attrs: { id: "addendum-detail-content" },
    },
    [
      _c(
        "tender-head",
        {
          ref: "tenderEditHead",
          attrs: { tenderGeneral: _vm.currentTender.general },
        },
        [
          _vm.isPicView || _vm.isRepresentative
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "note",
                      rawName: "v-note",
                      value: { text: _vm.noteText, enable: !_vm.editable },
                      expression: "{text:noteText, enable:!editable}",
                    },
                  ],
                  staticClass: "btn btn--darkblue nav-btn-top",
                  attrs: { disabled: !_vm.editable, type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.goEdit()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("action.edit")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isPicView
            ? _c("CancelAddendum", {
                attrs: {
                  disabled: !_vm.editable,
                  clickCheck: _vm.editableCheck,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isPicView && _vm.isFromSubmit
            ? _c("SubmitAddendum", {
                staticClass: "nav-btn-top",
                attrs: {
                  isUnderEditing: !_vm.editable,
                  clickCheck: _vm.editableCheck,
                  validateClosingDate: _vm.validateClosingDate,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "detail-summay-accordion-container" }, [
        _c(
          "ul",
          {
            staticClass: "accordion accordion-main accordion-customize",
            attrs: {
              id: "detail-summay-accordion",
              "data-accordion": "",
              "data-deep-link": "true",
              "data-allow-all-closed": "true",
              "data-multi-expand": "true",
              "data-update-history": "true",
              "data-deep-link-smudge": "500",
            },
          },
          [
            _c(
              "li",
              {
                staticClass: "accordion-item",
                attrs: { "data-accordion-item": "" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "accordion-title",
                    attrs: { href: "#detail-summary-tabs" },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("summary.name")))])]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "accordion-content",
                    attrs: {
                      "data-tab-content": "",
                      id: "detail-summary-tabs",
                    },
                  },
                  [_c("div", [_c("Addendum", { attrs: { isBid: false } })], 1)]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "accordion-item is-active",
                attrs: { "data-accordion-item": "" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "accordion-title",
                    attrs: { href: "#detail-summary-tabs" },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("tender.detail")))])]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "accordion-content",
                    attrs: {
                      "data-tab-content": "",
                      id: "detail-summary-tabs",
                    },
                  },
                  [
                    _c(
                      "div",
                      [
                        !_vm.isPreview
                          ? _c(
                              "div",
                              [
                                _c("closing-date", {
                                  ref: "closingDateAddendum",
                                  attrs: {
                                    partialClosingDate: _vm.partialClosingDate,
                                  },
                                  on: {
                                    "update:partialClosingDate": function (
                                      val
                                    ) {
                                      return (_vm.partialClosingDate = val)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "Tender",
                          [
                            _vm.isPicView || _vm.isRepresentative
                              ? _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "note",
                                        rawName: "v-note",
                                        value: {
                                          text: _vm.noteText,
                                          enable: !_vm.editable,
                                        },
                                        expression:
                                          "{text:noteText, enable:!editable}",
                                      },
                                    ],
                                    staticClass:
                                      "btn btn--darkblue nav-btn-top mini-btn",
                                    attrs: {
                                      type: "button",
                                      disabled: !_vm.editable,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.goEdit()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("action.edit")))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isPicView
                              ? _c("CancelAddendum", {
                                  staticClass: "nav-btn-top",
                                  attrs: {
                                    className: "btn btn--darkblue mini-btn",
                                    disabled: !_vm.editable,
                                    clickCheck: _vm.editableCheck,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isPicView && _vm.isFromSubmit
                              ? _c("SubmitAddendum", {
                                  staticClass: "nav-btn-top",
                                  attrs: {
                                    className: "btn btn--orange mini-btn",
                                    isUnderEditing: !_vm.editable,
                                    clickCheck: _vm.editableCheck,
                                    validateClosingDate:
                                      _vm.validateClosingDate,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("TenderRepresentative", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showTenderRep,
            expression: "showTenderRep",
          },
        ],
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }